/* @flow */

export const dataTableFields: Object = {
  current: {
    label: 'general:current',
    type: 'string',
  },
  user_name: {
    label: 'general:users.labels.name',
    type: 'string',
  },
  total_assets_assigned: {
    label: 'general:assets.total_assets_assigned',
    type: 'number',
  },
  total_account: {
    label: 'general:accounts.total_accounts',
    type: 'number',
  },
  assignedTo: {
    label: 'general:labels.assigned_to',
    type: 'string',
  },
  assigned_to: {
    label: 'general:labels.assigned_to',
    type: 'string',
  },
  model_submitted: {
    label: 'general:assets.labels.model_submitted',
    type: 'string',
  },
  model: {
    label: 'general:assets.labels.model_submitted',
    type: 'string',
  },
  submitted_by: {
    label: 'general:labels.submitted_by',
    type: 'string',
  },
  manufacturer_submitted: {
    label: 'general:manufacturers.labels.submitted',
    type: 'string',
  },
  asset_owner_name: {
    label: 'general:assets.labels.owner_name',
    type: 'string',
  },
  asset_status: {
    label: 'general:assets.labels.status',
    type: 'string',
  },
  company: {
    label: 'general:company',
    type: 'string',
  },
  country: {
    label: 'general:country',
    type: 'string',
  },
  site: {
    label: 'general:locations.labels.site',
    type: 'string',
  },
  building: {
    label: 'general:locations.labels.building_transport',
    type: 'string',
  },
  room: {
    label: 'general:locations.labels.lab_room',
    type: 'string',
  },
  workspace: {
    label: 'general:locations.labels.system_workspace',
    type: 'string',
  },
  calibration_certificate: {
    label: 'general:calibrations.certificate',
    type: 'string',
  },
  calibration_status: {
    label: 'general:calibrations.certificate',
    type: 'string',
  },
  calibration_due_in: {
    label: 'general:calibrations.labels.due_in',
    type: 'custom_date',
  },
  new_project_name: {
    label: 'general:projects.labels.new_name',
    type: 'string',
  },
  project_name: {
    label: 'general:projects.labels.name',
    type: 'string',
  },
  project_lead: {
    label: 'general:projects.labels.lead',
    type: 'string',
  },
  project_start_date: {
    label: 'general:projects.labels.start_date',
    type: 'date',
  },
  rental_ends_on: {
    label: 'general:assets.labels.rental_ends_on',
    type: 'date',
  },
  user_role_name: {
    label: 'general:roles.labels.current_role',
    type: 'string',
  },
  new_user_role: {
    label: 'general:roles.labels.role_level',
    type: 'new_user_role',
  },
  account_summary: {
    label: 'general:trading_accounts.labels.summary',
    type: 'account_summary',
  },
  manufacturer: {
    label: 'general:manufacturer',
    type: 'string',
  },
  manufacturer_code: {
    label: 'general:manufacturers.labels.code',
    type: 'string',
  },
  manufacturer_short_code: {
    label: 'general:manufacturers.labels.short_code',
    type: 'string',
  },
};
